import jQuery from 'jquery';

export const initVacancy = () => {
	jQuery(() => {
		jQuery('.js-vacancy').on('click', function (e) {
			e.preventDefault();
			const $href = jQuery(this).attr('href');
			const $offset = jQuery($href).offset().top;
			jQuery('html, body').animate({ scrollTop: `${$offset - 20}px` }, 700);
		});
	});
};
